import { DNode } from '@dojo/framework/core/interfaces';
import { RenderResult } from '@dojo/framework/core/interfaces';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';

import css from '../../css/micro.m.css';

export interface MicroCredentialCardProperties {
	xqa?: string;
}

export interface MicroCredentialCardChildren {
	leading?: RenderResult;
	trailing?: RenderResult;
	actions?: RenderResult;
}

const factory = create({
	theme
})
	.properties<MicroCredentialCardProperties>()
	.children<MicroCredentialCardChildren>();

export const MicroCredentialCard = factory(({ id: widgetId, properties, children, middleware: { theme } }): DNode => {
	const { root } = theme.classes(css);

	const { xqa = 'micro-credential-card' } = properties();

	let { leading, trailing, actions } = children()[0] as MicroCredentialCardChildren;

	if (!Array.isArray(leading)) {
		leading = [leading];
	}
	if (!Array.isArray(trailing)) {
		trailing = [trailing];
	}
	if (!Array.isArray(actions)) {
		actions = [actions];
	}

	return v('div', { widgetId, key: widgetId, xqa, classes: [theme.variant()] }, [
		v('div', { classes: [root] }, [...leading, ...trailing]),
		v('div', {}, [v('div', {}, actions)])
	]);
});

export default MicroCredentialCard;
